// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/basicsStyle
import { whiteColor, primaryBoxShadow } from 'styles/jss/original/base';

const styles = {
  icons: {
    width: '17px',
    height: '17px',
    color: whiteColor
  },
  box: {
    display: 'flex',
    background: whiteColor,
    position: 'fixed',
    bottom: '0',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    zIndex: '10',
    padding: '10px 0',
    marginBottom: '0',
    ...primaryBoxShadow
  }
};

export default styles;
